import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"plus\">\n  <path fill-rule=\"evenodd\" d=\"M121.5,153h-3v3a1,1,0,1,1-2,0v-3h-3a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h3v-3a1,1,0,1,1,2,0v3h3a1,1,0,0,1,1,1h0A1,1,0,0,1,121.5,153Z\" transform=\"translate(-112.5 -147)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/plus.svg
// module id = null
// module chunks = 